"use strict";
import { __require as l } from "./index.es325.js";
import { __require as t } from "./index.es323.js";
import { __require as o } from "./index.es324.js";
import { __require as n } from "./index.es467.js";
var r, e;
function m() {
  if (e) return r;
  e = 1;
  var i = l(), a = t(), u = o(), p = n();
  return r = p || i.call(u, a), r;
}
export {
  m as __require
};
//# sourceMappingURL=index.es406.js.map
